import { TalentCertificate } from "../../talents/talentAPI";
import ValidToLabel from "./ValidToLabel";
import { format, isBefore } from "date-fns";
import { useTranslation } from "react-i18next";

type Props = {
  certificate: Partial<TalentCertificate>;
};

export const CertificateValidTo = ({ certificate }: Props) => {
  const { t } = useTranslation(["common", "talentProfile"]);

  if (certificate?.rejectedBy || certificate?.rejectedAt)
    return <ValidToLabel color="error.main" label={t("common:rejected")} />;

  if (!certificate?.approvedAt && !certificate?.validTo)
    return (
      <ValidToLabel
        color="warning.main"
        label={t("talentProfile:unverified")}
      />
    );

  if (certificate?.validTo) {
    const validTo = new Date(certificate.validTo).setHours(0, 0, 0, 0);
    const today = new Date().setHours(0, 0, 0, 0);
    const isExpired = isBefore(validTo, today);

    if (isExpired) {
      return <ValidToLabel color="error.main" label={t("trainings:expired")} />;
    } else if (!certificate?.approvedAt && !certificate.rejectedAt) {
      return (
        <ValidToLabel
          color="warning.main"
          label={t("talentProfile:unverified")}
        />
      );
    }

    return (
      <ValidToLabel
        label={format(new Date(certificate?.validTo), "dd.MM.yyyy")}
      />
    );
  }

  return <ValidToLabel label={t("talentProfile:untilFurtherNotice")} />;
};
